module.exports = __webpack_public_path__ + "fonts/500-normal-cyrillic.16aed04.woff2";